/**
 * Глобальный поиск (§3.5): задачи, сотрудники и проекты во всех доступных
 * подразделениях. Общий для сайта и приложения.
 *
 * §29.3: SEARCH_MIN_LENGTH = 2 — короче запрос не уходит.
 */

import { api } from "./api";

export const SEARCH_MIN_LENGTH = 2;

export interface SearchHit {
  kind: "task" | "user" | "project";
  id: string;
  title: string;
  subtitle: string;
  /** Адрес на сайте — по нему же открывает экран и приложение. */
  url: string;
}

export const SEARCH_GROUP_LABELS: Record<SearchHit["kind"], string> = {
  task: "Задачи",
  user: "Сотрудники",
  project: "Проекты",
};

export const searchApi = api.injectEndpoints({
  endpoints: (build) => ({
    globalSearch: build.query<{ data: SearchHit[] }, string>({
      query: (query) => ({ method: "search.global", params: { query } }),
    }),
  }),
});

export const { useGlobalSearchQuery } = searchApi;
